import { Component, OnInit, Input } from '@angular/core';
import { SampleHistoryTable } from './models/sample-history-table';
import { Channel } from '../agptesting-newview/model/channel';

@Component({
  selector: 'app-apg-sample-result-view',
  templateUrl: './apg-sample-result-view.component.html',
  styleUrls: ['./apg-sample-result-view.component.css']
})
export class ApgSampleResultViewComponent implements OnInit {

  @Input() sampleHistory: any;
  @Input() sampleBarcode: string;
  @Input() sampleType: string;
  @Input() externalResult: string;

  samplePosition = '';

  columnHeaders384 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  rowHeaders384 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

  tables: SampleHistoryTable[] = [];

  constructor() { }

  public ngOnInit() {
    this.calculateSamplePosition();
    this.initalizeResultTables();
  }

  calculateSamplePosition() {
    if(this.sampleHistory && this.sampleHistory.samples && this.sampleHistory.samples.positionRow && this.sampleHistory.samples.prositionCol) {
      this.samplePosition = this.rowHeaders384[this.sampleHistory.samples.positionRow - 1] + this.columnHeaders384[this.sampleHistory.samples.prositionCol - 1];
    }
  }

  initalizeResultTables() {
    if(this.sampleHistory && this.sampleHistory.channelTestingTypeMapping && this.sampleHistory.channelTestingTypeMapping.length > 0) {
      this.sampleHistory.channelTestingTypeMapping.forEach(result => {
        let table = new SampleHistoryTable();
        table.header = result.diseaseName;
        table.channels = this.getChannelsFromSample(this.sampleHistory.samples, result.channelAssosiatedToDisease);
        table.finalresult = this.getResultFromSample(this.sampleHistory.samples, result.diseaseName);
        this.tables.push(Object.assign({}, table));
      })
    }
  }

  getChannelsFromSample(sample: any, channels: string[]) {
    let channelList: Channel[] = [];
    if(sample) {
      channels.forEach(innerChannel => {
        let channel = new Channel(innerChannel);
        channel.cpValue = sample.channels[innerChannel].cpValue;
        channel.geneResult = sample.channels[innerChannel].geneResult;
        channelList.push(Object.assign({}, channel));
      });
    }
    channelList.sort((channel1: Channel, channel2: Channel) => {
      return channel1.gene.localeCompare(channel2.gene);
    });
    return channelList;
  }

  getResultFromSample(sample: any, result: string) {
    let foundResult = null;
    if(sample.results) {
      sample.results.forEach(innerResult => {
        if(innerResult.testingType == result) {
          foundResult = innerResult.sampleResult;
        }
      });
    }
    if(!foundResult) {
      foundResult = sample.result;
    }
    return foundResult;
  }
}